module.exports = __webpack_public_path__ + "static/media/logoinova.a54244ce.png";